import React from 'react'
import { useSelector } from 'react-redux'

import { DoughnutChart } from '../../../../components/Charts/Dougnut/doughnut'

import { selectTopCategories } from '../../../../routing/fetchingfunction/dashboard/dashboard.reducer'

import { topCategoryColors } from '../../../../constants'

const AcceptClassDetailsClasses = () => {
  // TODO: add real data
  const allTopCategories = useSelector(selectTopCategories)

  const topCategories = allTopCategories.slice(0, 3)

  const tutorTopCategoriesContent = topCategories.map((category, index) => {
    const color = topCategoryColors[index]

    return (
      <div key={category.category} className="flex items-center">
        <div
          aria-hidden
          style={{ backgroundColor: color }}
          className="flex w-[20px] h-[20px] rounded-[6px] border-[1px]"
        />

        <div className="flex flex-col items-start justify-center ml-[6px]">
          <span style={{ color }} className="inline-block font-bold text-xs !text-[10px]">
            {category.category} ({category.booking_percentage}%)
          </span>

          <span className="inline-block text-primary-button text-xs">
            {category.total_bookings} Classes
          </span>
        </div>
      </div>
    )
  })

  return (
    <div className="w-[30%] flex flex-col p-[10px] bg-[#FFF5EE] border-[#FFCA84] border-[1px] rounded-[6px]">
      <div className="w-full flex justify-center items-center">
        <DoughnutChart topCategories={topCategories} />
      </div>

      <div className="w-full grid gap-[10px] mt-[10px]">{tutorTopCategoriesContent}</div>
    </div>
  )
}

export default AcceptClassDetailsClasses
